import React, { useEffect, useState } from 'react';
import { Row, Tooltip } from 'antd';
import AddBlockIcon from 'components/Icons/AddBlockIcon';
import VariableItem from './VariableItem';
import * as _ from 'lodash';

const VariablesPanel = ({
  tempPanelData,
  value,
  isSection,
  variables,
  addCustomVariable,
  ...rest
}) => {
  const [panelData, setPanelData] = useState(null);

  useEffect(() => {
    if (!_.isEqual(panelData, tempPanelData)) {
      setPanelData({ ...tempPanelData });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tempPanelData]);

  if (!panelData) {
    return null;
  }

  const panelDataKeys = Object.keys(panelData);

  return (
    <div className="variables-list">
      {panelDataKeys.map((variable, index) => (
        <VariableItem
          key={`variables-keys-${index}`}
          {...{
            value,
            variable,
            isSection,
            fallbackValueVariable: variables?.[value]?.[variable],
            tempPanelDataVariable: panelData[variable],
            ...rest,
          }}
        />
      ))}

      {!isSection && value === 'custom' && (
        <Row className={`items add-custom-field ${panelDataKeys.length > 0 ? 'multiple' : 'none'}`}>
          <Tooltip
            title="Add Custom Variable"
            className="elements-menu-drag"
            overlayClassName="elements-menu-tooltip">
            <AddBlockIcon className="add-custom-variable-icon" onClick={addCustomVariable} />
          </Tooltip>
        </Row>
      )}
    </div>
  );
};

export default VariablesPanel;
